import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setStudyBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    studiesRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import List from "./list"
import View from "./view"
import Edit from "./edit"

const Study = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { studyModuleAccess } = packageSettings
    const moduleAccess = studyModuleAccess === YES && moduleList[moduleIds.study].status === ACTIVE

    const baseRouteMask = `${projectBaseRoute}${studiesRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${studiesRoute}`

    useEffect(() => {
        dispatch(setStudyBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:studyId`}
                component={View}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:studyId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default Study
